import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Currency } from '../model/currency';

@Injectable({
    providedIn: 'root'
  })
  export class CurrencyService{

    constructor(private _restClientService : RestClientService) { }
    
      
    getAllCurrencies() {
        return this._restClientService.load<Currency[]>('currency/get');
    }
        


}      

    